import { render, staticRenderFns } from "./KPIForm.vue?vue&type=template&id=51affbe0&scoped=true"
import script from "./KPIForm.vue?vue&type=script&lang=js"
export * from "./KPIForm.vue?vue&type=script&lang=js"
import style0 from "./KPIForm.vue?vue&type=style&index=0&id=51affbe0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51affbe0",
  null
  
)

export default component.exports